import { Pipe, PipeTransform, inject } from '@angular/core';

import { AuthService } from '../services/auth/auth.service';

@Pipe({
  name: 'permissions',
  standalone: false,
})
export class PermissionsPipe implements PipeTransform {
  private readonly _authService = inject(AuthService);

  async transform(requiredPermissions: string[] | string): Promise<boolean> {
    if (!Array.isArray(requiredPermissions)) {
      requiredPermissions = [requiredPermissions];
    }

    const userPermissions = await this._authService.getUserPermissions();

    if (requiredPermissions.length && requiredPermissions.includes('SOME')) {
      return requiredPermissions.some(permission =>
        userPermissions.includes(permission)
      );
    }

    return requiredPermissions.every(permission =>
      userPermissions.includes(permission)
    );
  }
}
